// extracted by mini-css-extract-plugin
export var link = "_rd-0";